// TODO: should this be renamed PeriodEnd ?
export enum PerformanceView {
  MONTHLY = 'MONTHLY',
  QUARTERLY = 'QUARTERLY',
  CUSTOM = 'CUSTOM',
}
